import { Link } from "react-router-dom";
import { ArrowRight, Building2, Package } from "lucide-react";
import { Card } from "@/components/ui/card";

// AUT-41: the bottom-right card of GlobalProhibitedKeywordsTab -- this page manages only
// the global tier, so this points to where the narrower tiers actually live. Static,
// no props: neither destination depends on anything this tab knows about.
export function ProhibitedKeywordsScopePointer() {
  return (
    <Card className="p-6 space-y-3">
      <div>
        <h3 className="text-base font-semibold text-foreground">Brand &amp; Product Prohibited Keywords</h3>
        <p className="text-sm text-muted-foreground mt-1">
          This page manages the global list only. Narrower scopes live with their context.
        </p>
      </div>
      <Link
        to="/brand-context"
        className="flex items-start gap-3 rounded-lg border border-border p-3 hover:bg-muted transition-colors group"
      >
        <Building2 className="h-4 w-4 text-foreground shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-foreground">Brand-specific keywords</div>
          <p className="text-sm text-muted-foreground mt-0.5">
            Manage from Brand → <span className="font-medium text-foreground">Brand Context</span>
          </p>
        </div>
        <ArrowRight className="h-4 w-4 text-muted-foreground shrink-0 group-hover:translate-x-0.5 transition-transform" />
      </Link>
      <div className="flex items-start gap-3 rounded-lg border border-border p-3">
        <Package className="h-4 w-4 text-foreground shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-foreground">Product-specific keywords</div>
          <p className="text-sm text-muted-foreground mt-0.5">
            Open any product, then use the kebab menu at the top of the product page to open Prohibited Keywords.
          </p>
        </div>
      </div>
    </Card>
  );
}
